import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import get from 'lodash/get';
import { HEADER_OFFSET } from '../../../constants';
import { BREAKPOINTS } from '../../../utils/commonHelper';
import { getTargeting } from './resources/adsConfig';
import adParams from './resources/adParams';
import AdProvider from '../../../components/Ads/AdProvider';
import BreadCrumb from '../../../components/BreadCrumb';
import ProductSchema from '../../../components/Schema/ProductSchema';
import Meta from '../../../components/Meta';
import { getBreadCrumb } from '../utils/breadcrumb';
import * as meta from '../utils/meta';
import NextPrevious from '../NextPrevious';
import Sticky from '../../../components/Sticky';
import { YoutubeVideos } from '@dmm/lib-react-videos';
import * as listingHelper from '../../../utils/listingHelper';
import { getCurrency } from '../../../utils/uomHelper';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import NextPreviousDataProvider from '../NextPreviousDataProvider';
import StickyContact from '../StickyContact';
import ImmersiveTourModal from '../../../components/ImmersiveTourModal';
import * as immersiveTourHelper from '../../../utils/immersiveTourHelper';
import SidePopUp from '../../../components/SidePopUP';
import SaveSearchFromDetails from '../../../components/SaveSearchFromDetails';
import ConversationalCta from '../../../components/ConversationalCta';
import './styles.css';
import './stylesBDP.css';
import BDPEmailLeadForm from '../BDPSections/BDPEmailLeadForm';
import BDPBoatSummary from '../BDPSections/BDPBoatSummary';
import BDPStepperModal from '../BDPSections/BDPStepperModal';
import classnames from 'classnames';
import { calculateMonthlyPrice, goToApplyNow, isFinanceSegmentCandidate, makeFinanceableSummaryTrackingEvent } from '../../../utils/trident';
import {
  ColumnContainer,
  BoatDetails,
  HorizontalGallery,
  ListingCarouselCard,
  ContactCard,
  SummaryCTA,
  HeadingTag,
  SellerName,
  FlexLinks,
  ModalWrapper
} from '@dmm/lib-react-ui-components';
import { getSecondAdParams } from './bdpController/bdpHelpers';
import { useBdp } from './bdpController/bdpManager';
import BDPCarouselModal from '../BDPSections/BDPCarouselModal';
import BDPEmailLeadFormModal from '../BDPSections/BDPEmailLeadFormModal';
import AccordionDetails from '../DetailsSection/AccordionDetails';
import { setCollapseContentTracking } from '../../../store/actions/dataLayer';
import { Calculator } from '../../../components/Calculator';
import { CalculatorFinanceable } from '../../../components/CalculatorFinanceable';
import { FinanceableBoatSummary } from '../FinanceableBoatSummary';
import { setGenericEvent } from '../../../store/actions/dataLayer';
import { useIntl } from 'react-intl';
import { getMessages } from '../../../tppServices/translations/messages';
import { getBoatConstantsFromI18n } from '../../../tppServices/translations/constants';
import { isContactFormSticky } from '../../../utils/newBDPHelper';
import { PortalConfigContext } from '../../../config/portal';
import { getItem, removeItem } from '../../../utils/storage';
import { getPartyBrandedSRP } from '../../../utils/urlHelpers/party';
import { useLeadFormTracking } from './bdpController/useBdpForm';
import { AdDisplayer } from '../../../components/Ads/AdDisplayer/AdDisplayer';
import { AD_PAGE_KEY, getInPageAdsConfig } from '../../../utils/ads/adsUtils';

const LiveVideoTourModal = loadable(
  () => import('../../../components/LiveVideoTourModal')
);

const BrokerDealerBDP = (props) => {
  const { state, setState, bdp, featureFlags } = useBdp(props);
  const { featureFlagMandatoryPhone, featureFlagQuestionnaire } = featureFlags;
  const { bdpContext, handlers, selectors, actions, carouselButtons } = bdp;
  const { additionalLeadsModalOpen, listings } = selectors;
  const showSimilarListingsModal = additionalLeadsModalOpen && listings.length > 0 && state.breakpoint !== BREAKPOINTS.desktop;

  const { setGenericEventAction, createSearchAlertAction } = actions;
  const {
    uom,
    seoConfig,
    customMeta,
    showThirdAdbox,
    portal,
    supportsSavedSearchOnBDP,
    pageAdsConfig,
    customUom,
    servicesItems,
    showMoreInventory,
    supportsTridentCalculator,
    supportsConversationalCta,
    customPricingOptions,
    summaryCtaProps,
    sellerNameProps
  } = bdpContext;
  const {
    hideModal,
    handleOpenContactModal,
    handleCloseContactModal,
    handleCloseLeadHygieneModal,
    handleContactCardScroll,
    toggleVideoTourModal,
    handleOpenContactForm,
    openImmersiveTourModal,
    openLeadHygieneModal,
    openStepperLeadHygieneModal,
    openCarousel,
    dealerWebsiteAddLead,
    viewInventoryAddLead,
    previousNextHandler
  } = handlers;

  const {
    listing,
    isWorking,
    carouselClickCount,
    tridentTeaserRate,
    tridentLoanAmount,
    tridentTermInMonths,
    ctaLink,
    showMonthlyCalculatorOnly,
    navLinks,
    cookies,
    abTestContext,
    adsData
  } = props;

  const targeting = getTargeting(
    listing,
    customUom && customUom.length ? customUom.length.abbr : uom
  );

  const context = useContext(PortalConfigContext);
  const breadCrumbItems = getBreadCrumb(listing, state.breakpoint);
  const numCarouselClickToReloadPageAds = 3;
  const numCarouselClickToReloadModalAds = 5;
  const pageAdReload =
    Math.floor(carouselClickCount / numCarouselClickToReloadPageAds) || 0;
  const modalAdReload =
    Math.floor(carouselClickCount / numCarouselClickToReloadModalAds) || 0;
  const secondAdBoxParams = getSecondAdParams(
    showThirdAdbox,
    pageAdReload,
    adParams
  );

  const newAdsConfig = getInPageAdsConfig(context, AD_PAGE_KEY.DETAILS, adsData, abTestContext, cookies);

  const monthlyPrice = calculateMonthlyPrice(
    tridentTeaserRate,
    tridentTermInMonths,
    tridentLoanAmount
  );

  const { next, previous } = navLinks;
  const hidden = !previous && !next;

  const intl = useIntl();
  const t = intl.formatMessage;
  const messages = getMessages();

  const [price, setPrice] = useState(tridentLoanAmount);
  const hideTridentFeatures = listing?.owner?.hideTridentFeatures ?? false;

  const boatConstants = getBoatConstantsFromI18n();
  const isFSBOSeller = listingHelper.isFSBOContact(listing.contact);
  const dealerListings = listing.dealerListings;
  const dealerWebsite = get(listing, 'contact.website');
  const contactFormSticky = isContactFormSticky(context);
  const shouldShowFinanceSummary = isFinanceSegmentCandidate(listing);
  const displayBottomMobileAd = !contactFormSticky && state.breakpoint === BREAKPOINTS.mobile;

  let isFormSubmitted = getItem(`formSubmitted-${listing.id}`) === 'true';
  const oneDay = 24 * 60 * 60 * 1000;
  const now = new Date();
  const itemTimestamp = getItem(
    `formSubmitted-${listing.id}-timestamp`
  );
  if (isFormSubmitted && (now.getTime() - itemTimestamp > oneDay)) {
    removeItem(`formSubmitted-${listing.id}`);
    removeItem(`formSubmitted-${listing.id}-timestamp`);
    isFormSubmitted = false;
  }


  const getDealerLogo = (listing) => {
    const { enhanced, default: defaultLogo } = listing?.owner?.logos || {};
    const logo = enhanced || defaultLogo || '';
    const formattedLogoURL = logo.replace(/^http:\/\//, 'https://');
    const resizedLogo = listingHelper.addResizeParams(formattedLogoURL, { width: 122, height: 115 }, undefined, true, 'webp');
    return resizedLogo;
  };

  const getDealerListingsCarousel = (dealerListings) => {
    return dealerListings.map((listing) => {
      return (
        <ListingCarouselCard
          key={listing.id}
          name={listingHelper.getTitle(listing)}
          price={listingHelper.getPrice(listing, customPricingOptions)}
          sellerMarketingMessage={listingHelper.getLocation(listing)}
          image={listingHelper.addResizeParams(listing.media[0]?.url, { width: 308, height: 205 }, listing.media[0]?.date?.modified, true, 'webp')}
          imageAlt={listingHelper.getTitle(listing)}
          hyperlinkAttributes={{
            'data-listing-id': listing.id,
            'data-reporting-click-product-id': listing.id,
            'data-reporting-click-listing-type':
            boatConstants.LISTING_SAME_DEALER,
            href: listing.href,
            target: '_blank'
          }}
        />
      );
    });
  };

  useEffect(() => {
    const hidden = get(listing, 'price.hidden');
    setPrice(!hidden && tridentLoanAmount);
  }, [listing, tridentLoanAmount]);

  const trackEvent = (actionLabel, actiontType) => {
    const trackingEvent = makeFinanceableSummaryTrackingEvent(actionLabel, actiontType);
    window.dataLayer.push(trackingEvent);
  };

  const handlePreQualify = (e) => {
    e.preventDefault();
    trackEvent('loan calculation', 'payment calculator - apply now bdp');
    goToApplyNow(listing);
  };

  const handleOnSuccessContactForm = (leadData, onSuccess = openLeadHygieneModal) => {
    if (shouldShowFinanceSummary) {
      trackEvent('contact form submit', 'contact form submit');
    }
    onSuccess(leadData);
  };

  const handleClickContactForm = (e, UIEvent) => {
    if (shouldShowFinanceSummary) {
      trackEvent(state.breakpoint === BREAKPOINTS.desktop ? 'contact seller' : 'contact seller sticky footer', 'click');
    }
    let shouldConvertCustomLeadHygieneGoal = true;
    if (state.breakpoint === BREAKPOINTS.mobile || state.breakpoint === BREAKPOINTS.tablet) {
      shouldConvertCustomLeadHygieneGoal = false;
    }
    handleOpenContactForm(e, UIEvent, shouldConvertCustomLeadHygieneGoal);
  };

  const make = get(listing, 'make', null);
  const dealer = get(listing, 'owner', null);
  const href = getPartyBrandedSRP(dealer, false, make);

  const dealerLinks = [
    {
      show: showMoreInventory,
      text: t(messages.moreFromDealer),
      href: href,
      hyperlinkAttributes: {
        'data-reporting-click-internal-link-id': 'more from this dealer'
      },
      onClick: viewInventoryAddLead
    },
    {
      show: dealerWebsite,
      svg: 'externalLink',
      alt: 'external link icon',
      text: t(messages.viewDealerWebsite),
      href: dealerWebsite,
      onClick: dealerWebsiteAddLead,
      hyperlinkAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      }
    }
  ];
  const {handlePhoneCall} = useLeadFormTracking(listing.id);
  sellerNameProps.onClickPhoneMessage = handlePhoneCall;
  const displayStepperModal = featureFlagQuestionnaire || state.breakpoint === BREAKPOINTS.desktop;
  const showContactScrollBar = state.breakpoint === BREAKPOINTS.desktop && state.scrolledPastContactCard;

  return (
    <>
      <ImmersiveTourModal
        isOpen={state.showImmersiveTourModal}
        closeModal={() => setState({ ...state, showImmersiveTourModal: false })}
        title={immersiveTourHelper.getTitle(listing)}
        url={get(listing, 'virtualTour.url')}
      />
      <AdProvider
        url={get(props, 'location.pathname', '')}
        isWorking={props.isWorking}
        targeting={targeting}
        adsConfig={pageAdsConfig}
      >
        <Meta
          noindex={meta.getNoIndex()}
          canonical={meta.getCanonical(listing)}
          next={meta.getLinkRelNext()}
          prev={meta.getLinkRelPrev()}
          title={meta.getMetaTitle(listing, portal, seoConfig, customUom)}
          description={meta.getMetaDescription(listing, portal, customMeta)}
        />
        <ProductSchema
          listing={listing}
          labels={{
            getTitle: listingHelper.getTitle,
            getCurrency: getCurrency
          }}
        />
        <NextPreviousDataProvider {...props} />

        {/* Saved search popup */}
        {supportsSavedSearchOnBDP && (
          <SidePopUp
            listingId={listing.id}
            hideSavedSearchPopup={state.hideSavedSearchPopup}
            tracking={{ setGenericEvent: setGenericEventAction }}
            portal={portal}
          >
            <SaveSearchFromDetails
              idPrefix="modal-save-search-section"
              data={listingHelper.getSavedSearchDetailsData(listing)}
              searchPath={listingHelper.getSavedSearchDetailsSearchPath(
                listing
              )}
              createSearchAlert={createSearchAlertAction}
              tracking={{
                setGenericEvent: setGenericEventAction,
                submitEvent: 'SaveSearchPopupSubscribed'
              }}
              listingId={listing.id}
              portal={portal}
            />
          </SidePopUp>
        )}

        <div className="boat-details bdp-broker-dealer">
          { displayStepperModal ?
            <BDPStepperModal
              breakpoint={state.breakpoint}
              show={state.showContactModal}
              onClose={handleCloseContactModal}
              onSuccess={(leadData) => {
                handleOnSuccessContactForm(leadData, openStepperLeadHygieneModal );
              }
              }
              listing={listing}
              portal={portal}
              navLinks={navLinks}
              customPricingOptions={customPricingOptions}
              listings={listings}
              shouldConvertCustomLeadHygieneGoal={state.shouldConvertCustomLeadHygieneGoal}
              featureFlagMandatoryPhone={featureFlagMandatoryPhone}
              featureFlagQuestionnaire={featureFlagQuestionnaire}
            />
            :
            <ModalWrapper show={state.showContactModal} onClose={handleCloseContactModal} customClassName="email-lead-form-modal-wrapper" >
              <BDPEmailLeadFormModal
                breakpoint={state.breakpoint}
                onClose={handleCloseContactModal}
                listing={listing}
                portal={portal}
                onSuccess={handleOnSuccessContactForm}
                featureFlagMandatoryPhone={featureFlagMandatoryPhone}
              />
            </ModalWrapper>
          }
          <div id="root-anchor"></div>
          <div className="bdp-top-ad desktopOnly">
            <AdDisplayer
              newAdsConfig={newAdsConfig}
              adSlot={'leaderboard-top'}
              googleAdParams={adParams.leaderboardBDPTopParams}
              pageAdReload={pageAdReload} />
          </div>
          <div className="bdp-top-ad mobileOnly">
            <AdDisplayer
              newAdsConfig={newAdsConfig}
              adSlot={'mobile-leaderboard-top-1'}
              googleAdParams={adParams.mobileBDPLeaderboardParams}
              pageAdReload={pageAdReload} />
          </div>
          { showContactScrollBar && (
              <SummaryCTA
                className="bdp-boat-summary-cta"
                customClassNames={{ simplified: true }}
                hideSave={true}
                summary={summaryCtaProps}
                contactBtnText={t(messages.contactForm.contactButton)}
                hidePreQualifiedButton={!shouldShowFinanceSummary}
                preQualifiedBtnText={t(
                  messages.loanCalculators.financeable.getPrequal
                )}
                onClickPreQualified={handlePreQualify}
                onClickRequestInfo={handleClickContactForm}
              />
            )}
          <div
            className={classnames('nextPrevBDP', {
              'scroll': state.scrolledPastBoatSummary,
              'desktopOnly': hidden,
              'not-sticky': true
            })}
          >
            <NextPrevious
              listing={listing}
              breadCrumbs={breadCrumbItems}
              navLinks={props.navLinks}
              isLoading={isWorking}
              breakpoint={state.breakpoint}
              showInfo={state.scrolledPastBoatSummary}
              tracking={{ setGenericEvent: setGenericEventAction }}
              longNextPrevious={true}
            />
          </div>
          <div className="top broker-bdp">
            <div className="broker-bdp-left">
              <div className="left-wrapper">
                <BDPCarouselModal
                  breakpoint={state.breakpoint}
                  isLoading={isWorking}
                  show={state.showModalCarousel}
                  carouselIndex={state.carouselIndex}
                  hideModal={hideModal}
                  carouselAddParams={adParams}
                  carouselButtons={carouselButtons}
                  handleOpenContactForm={handleOpenContactForm}
                  openImmersiveTourModal={openImmersiveTourModal}
                  handleCarouselItemClick={(e, index) => openCarousel(index)}
                  previousNextHandler={previousNextHandler}
                  adReload={modalAdReload}
                  pageAdsConfig={pageAdsConfig}
                  targeting={targeting}
                  bdpUrl={get(props, 'location.pathname', '')}
                />
                <div className="mobileOnly">
                  <BreadCrumb items={breadCrumbItems} />
                  <BDPBoatSummary
                    listing={listing}
                    monthlyPrice={monthlyPrice}
                    supportsTridentCalculator={supportsTridentCalculator}
                    customUom={customUom ? customUom.length : undefined}
                    overwriteDataTestId="email-lead-form-mobile"
                  />
                </div>
                <div className="content">
                  <div className="details">
                    <BoatDetails
                      details={listingHelper.getBoatDetails(listing, customUom)}
                    />
                    <div className="mobileOnly lead-hygiene">
                      <>
                        <BDPEmailLeadForm
                          listing={listing}
                          portal={portal}
                          onSuccess={handleOnSuccessContactForm}
                          overwriteDataTestId="email-lead-form-mobile"
                          idPrefix="mobile"
                          featureFlagMandatoryPhone={featureFlagMandatoryPhone}
                          featureFlagQuestionnaire={featureFlagQuestionnaire}
                        />
                        {shouldShowFinanceSummary &&
                          <FinanceableBoatSummary listing={listing} trackPreQualify={trackEvent}/>
                        }
                      </>
                    </div>
                    <AccordionDetails
                      listing={listing}
                      setCollapseContentTracking={setCollapseContentTracking}
                      onOpenContactForm={handleOpenContactModal}
                      customUom={customUom}
                    />
                    {!isFSBOSeller && dealerListings && dealerListings.length > 0 && (
                      <div className="more-from-dealer-section lead-hygiene">
                        <>
                          <HeadingTag headingLevel={2} heading={t(messages.moreFromDealer)}/>
                          <SellerName {...sellerNameProps}/>
                        </>
                        <HorizontalGallery hideArrowButtons={false}>
                          {getDealerListingsCarousel(dealerListings)}
                        </HorizontalGallery>
                        <FlexLinks links={dealerLinks}/>
                      </div>
                    )}
                    {supportsTridentCalculator &&
                      !shouldShowFinanceSummary && (
                        <div
                          className="calculator-section payment-calculator auto-calculator"
                          id="scroll-to-calculator"
                        >
                          <Calculator
                            setGenericEvent={setGenericEvent}
                            tridentLoanAmount={price}
                            tridentTeaserRate={tridentTeaserRate}
                            tridentTermInMonths={tridentTermInMonths}
                            ctaLink={ctaLink}
                            showMonthlyCalculatorOnly={
                              showMonthlyCalculatorOnly
                            }
                            isPrequalCTA={true}
                            showCTAs={false}
                            hideTridentFeatures={hideTridentFeatures}
                          />
                        </div>
                      )}
                    {supportsTridentCalculator &&
                      shouldShowFinanceSummary && (
                        <div id="scroll-to-calculator">
                          <CalculatorFinanceable
                            setGenericEvent={setGenericEvent}
                            tridentLoanAmount={price}
                            tridentTeaserRate={tridentTeaserRate}
                            tridentTermInMonths={tridentTermInMonths}
                            listing={listing}
                          />
                        </div>
                      )}
                    {servicesItems && servicesItems.length > 0 && (
                      <div className="services-section">
                        <h3 className="bdp-section-title">
                          {t(messages.servicesDetails)}
                        </h3>
                        <div className="services">
                          {servicesItems.map((service, idx) => (
                            <AdDisplayer
                              newAdsConfig={newAdsConfig}
                              adSlot={`service-button-${idx + 1}`}
                              key={idx}
                              googleAdParams={adParams[`services${service}`]} />
                          ))}
                        </div>
                      </div>
                    )}
                    {listing.videos && listing.videos.length > 0 && (
                      <div className="expert-reviews-section">
                        <h3 className="bdp-section-title">
                          {t(messages.videoDetails)}
                        </h3>
                        <YoutubeVideos
                          videos={listing.videos}
                          portal={portal}
                          device={state.breakpoint}
                        />
                      </div>
                    )}
                    <ConversationalCta
                      id="cta-section"
                      enabled={supportsConversationalCta}
                      variant="simple"
                      title={t(
                        messages.boatDetails.moreQuestions.conversationalCta
                          .title
                      )}
                      link={{
                        text: t(
                          messages.boatDetails.moreQuestions.conversationalCta
                            .linkText
                        ),
                        onClick: (event) =>
                          handleOpenContactModal(event, false, {
                            prePopulatedText: t(
                              messages.boatDetails.moreQuestions
                                .conversationalCta.prePopulatedText,
                              { portal }
                            )
                          })
                      }}
                      classNames={{ untruncate: true }}
                    >
                      {t(
                        messages.boatDetails.moreQuestions.conversationalCta
                          .body.firstRow
                      )}
                      <br />
                      {t(
                        messages.boatDetails.moreQuestions.conversationalCta
                          .body.secondRow
                      )}
                    </ConversationalCta>
                  </div>
                </div>
              </div>
            </div>
            <div className="top-right broker-bdp-right">
              {contactFormSticky && (
                <div className="column-container-sticky">
                  <ColumnContainer>
                    <BDPBoatSummary
                      listing={listing}
                      monthlyPrice={monthlyPrice}
                      supportsTridentCalculator={supportsTridentCalculator}
                      customUom={customUom ? customUom.length : undefined}
                      lite={true}
                    />
                    <BDPEmailLeadForm
                      listing={listing}
                      portal={portal}
                      onSuccess={handleOnSuccessContactForm}
                      noShadow={true}
                      lightBorder={true}
                      idPrefix="desktop"
                      featureFlagMandatoryPhone={featureFlagMandatoryPhone}
                    />
                  </ColumnContainer>
                </div>
              )}
              {state.breakpoint === BREAKPOINTS.desktop && (
                <>
                  <ColumnContainer>
                    <BDPBoatSummary
                      listing={listing}
                      monthlyPrice={monthlyPrice}
                      supportsTridentCalculator={supportsTridentCalculator}
                      customUom={customUom ? customUom.length : undefined}
                      lite={true}
                    />
                    <>
                      <ContactCard
                        src={getDealerLogo(listing) || ''}
                        alt={listing.owner?.name}
                        listedByText={t(messages.contactForm?.listedBy)}
                        sellerName={listing.contact?.name}
                        phoneText={t(messages.contactGroup?.phoneReveal)}
                        phoneNumber={listing.contact?.phone}
                        buttonLabel={t(messages.contactForm.contactButton)}
                        handleClick={handleClickContactForm}
                        showConfirmationMessage={isFormSubmitted}
                        successMessage={t(
                          messages.additionalLeads.leadSuccessMessage
                        )}
                        onClickPhoneMessage={handlePhoneCall}
                      />
                      <Sticky
                        position="top"
                        offset={HEADER_OFFSET}
                        onChange={handleContactCardScroll}
                      />
                    </>
                    {shouldShowFinanceSummary &&
                      <FinanceableBoatSummary listing={listing} trackPreQualify={trackEvent}/>
                    }
                  </ColumnContainer>
                  <div className="right-ad">
                    <div className="sticky-ads">
                      <div className="add-tmp">
                        <AdDisplayer
                          newAdsConfig={newAdsConfig}
                          adSlot={'box-1'}
                          googleAdParams={adParams.sideBarAd1Params}
                          pageAdReload={pageAdReload} />
                      </div>
                      <div className="add-tmp">
                        <AdDisplayer
                          newAdsConfig={newAdsConfig}
                          adSlot={'box-2'}
                          googleAdParams={secondAdBoxParams} />
                      </div>
                      {showThirdAdbox && (
                        <div className="add-tmp">
                          <AdDisplayer
                            newAdsConfig={newAdsConfig}
                            adSlot={'box-3'}
                            googleAdParams={adParams.sideBarAd3Params} />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {displayBottomMobileAd && (
            <div className="isMobile">
              <AdDisplayer
                newAdsConfig={newAdsConfig}
                adSlot={'mobile-box-2'}
                googleAdParams={adParams.mobileBox2Params} />
            </div>
          )}
        </div>
        {(state.breakpoint === BREAKPOINTS.mobile ||
          (state.breakpoint === BREAKPOINTS.tablet &&
            !state.showModalCarousel)) && (
          <StickyContact
            isManufacturer={false}
            isManuFacturerForm={false}
            isLoading={isWorking}
            listing={listing}
            onOpenContact={handleClickContactForm}
            isModalCarouselShown={state.showModalCarousel}
            breakpoint={state.breakpoint}
          />
        )}
        { showSimilarListingsModal &&
          <BDPStepperModal
            skipFirstStep={true}
            featureFlagQuestionnaire={featureFlagQuestionnaire}
            show={state.showLeadConfirmationModal}
            onClose={handleCloseLeadHygieneModal}
            breakpoint={state.breakpoint}
            navLinks={navLinks}
            customPricingOptions={customPricingOptions}
            listings={listings}
          />
        }
        {state.showVideoTourForm && (
          <LiveVideoTourModal
            listingId={listing.id}
            onClose={toggleVideoTourModal}
          />
        )}
      </AdProvider>
    </>
  );
};

BrokerDealerBDP.defaultProps = {
  navLinks: {}
};

BrokerDealerBDP.propTypes = {
  isWorking: PropTypes.bool,
  listing: listingPropTypes,
  listings: PropTypes.array,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string
  }),
  carouselClickCount: PropTypes.number,
  pageType: PropTypes.string,
  boatLoansSection: PropTypes.object,
  ficoScores: PropTypes.array,
  tridentTeaserRate: PropTypes.number,
  tridentLoanAmount: PropTypes.number,
  tridentTermInMonths: PropTypes.number,
  showMonthlyCalculatorOnly: PropTypes.bool,
  ctaLink: PropTypes.string,
  cookies: PropTypes.object,
  abTestContext: PropTypes.object,
  adsData: PropTypes.object
};

export default BrokerDealerBDP;
